let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5HTv6")).then(() => parcelRequire('f4NfX'));